module.exports = __webpack_public_path__ + "static/img/1.485bb26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/1.png
// module id = oM4i
// module chunks = 0